// extracted by mini-css-extract-plugin
export default {"buttonBottom":"AddKpi_buttonBottom__OlhCu","buttonSubmit":"AddKpi_buttonSubmit__-mCRg","buttonBack":"AddKpi_buttonBack__5N5Jn"};